// source: witbooking/backoffice/orchestrator/segment/v1/segment_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.Segment', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.segment.v1.Segment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.segment.v1.Segment.displayName = 'proto.witbooking.backoffice.orchestrator.segment.v1.Segment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest;
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    segment: (f = msg.getSegment()) && proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse;
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.segment.v1.Segment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader);
      msg.setSegment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Segment segment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.prototype.getSegment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.segment.v1.Segment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.segment.v1.Segment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.prototype.setSegment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.prototype.clearSegment = function() {
  return this.setSegment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.prototype.hasSegment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest;
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    segmentsList: jspb.Message.toObjectList(msg.getSegmentsList(),
    proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse;
  return proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.segment.v1.Segment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader);
      msg.addSegments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Segment segments = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.segment.v1.Segment>}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.prototype.getSegmentsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.segment.v1.Segment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.segment.v1.Segment, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.segment.v1.Segment>} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.prototype.setSegmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.prototype.addSegments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.segment.v1.Segment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.prototype.clearSegmentsList = function() {
  return this.setSegmentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    segment: (f = msg.getSegment()) && proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest;
  return proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.segment.v1.Segment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader);
      msg.setSegment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSegment();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Segment segment = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.getSegment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.segment.v1.Segment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.segment.v1.Segment, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.setSegment = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.clearSegment = function() {
  return this.setSegment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest.prototype.hasSegment = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    segment: (f = msg.getSegment()) && proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse;
  return proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.segment.v1.Segment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader);
      msg.setSegment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Segment segment = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.prototype.getSegment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.segment.v1.Segment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.segment.v1.Segment, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.prototype.setSegment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.prototype.clearSegment = function() {
  return this.setSegment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.prototype.hasSegment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    segment: (f = msg.getSegment()) && proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest;
  return proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.segment.v1.Segment;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader);
      msg.setSegment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSegment();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Segment segment = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.getSegment = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.segment.v1.Segment} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.segment.v1.Segment, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.segment.v1.Segment|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.setSegment = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.clearSegment = function() {
  return this.setSegment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest.prototype.hasSegment = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse;
  return proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest;
  return proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse;
  return proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.segment.v1.Segment;
  return proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.segment.v1.Segment} returns this
 */
proto.witbooking.backoffice.orchestrator.segment.v1.Segment.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.orchestrator.segment.v1);
